import React, { useRef, useState } from "react";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { ErrorMessage, useForm } from "react-hook-form";
import { connect } from "react-redux";
import * as Yup from "yup";

// components
import SlideLangs from "./_langs";
import { ButtonCancel, ButtonSubmit, GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {
    FORM, INTERNATIONAL,
    LB_ACTIVE,
    LB_CODE,
    MAX_NAME,
    REQUIRED
} from "../../../components/i18n/i18n";
import { MAX_NAME_SIZE } from "../../../components/menu-flower/constants";
import { TT_HISTORY } from "../../../components/i18n/toolTips";

// services
import { slideService } from "../../../jwt/_services/campaign/slideService";
import {paramSettingsProvider} from "../../../providers/paramSettingsProvider";
import {showLoader} from "../../../components/loader/loader";
import SelectGeneric from "../../../components/select/selectGeneric";

const SlideForm = props => {
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const domainObject = props.itemToEdit
    const editMode = !!domainObject.id
    const [showModal, setShowModal] = useState(true)
    const [status, setStatus] = useState( domainObject?.status || false)
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [imageOption, setImageOption] = useState(domainObject?.image_type || '');
    const [showLoading, setShowLoading] = useState(false);

    const translatableLangs = domainObject?.translatedLangs || []

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
    });

    const {register, handleSubmit, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            code: domainObject?.code,
            color: domainObject?.color != null ?  domainObject?.color : '#FFF',
            image: domainObject?.image,
            showOrder: domainObject?.showOrder
        }
    });

    const onSubmit = async (data, _) => {
        setShowLoading(true)

        let dataRequest = {
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                status,
                image_type: imageOption,
                campaign: { id: props.parent?.id},
                langs
            }
        };

        if (editMode) {
            let id = domainObject?.id;
            dataRequest.item.id = id

            await slideService.updateItem( id, dataRequest)
        } else {
            await slideService.saveItem(dataRequest)
        }

        setShowLoading(false)
        closeForm()
    };

    const closeForm = () => {
        props.setShowItem(false)
        props.setItemToEdit({})
    }

    return (<>
        { showLoading && showLoader() }
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input type="text" name="code"
                                       placeholder={LB_CODE}
                                       innerRef={register}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Imagen</Label>
                                <Input type="text"
                                       name="image"
                                       placeholder="imagen"
                                       innerRef={register}
                                       className={(errors.description ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="startDate" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Orden de presentación</Label>
                                <Input type="number"
                                       name="showOrder"
                                       min={0}
                                       innerRef={register}
                                       className={(errors.description ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="color" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Formato de imagen</Label>
                                <SelectGeneric
                                    title={ 'Formato de imagen' }
                                    initialValue={ imageOption }
                                    setExternalValue={ setImageOption }
                                    provider={ paramSettingsProvider }
                                    customFilter={{item:{ps_key: 'xkynet_config_slide_formats'}} }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Color</Label>
                                <Input type="color"
                                       name="color"
                                       innerRef={register}
                                       className={(errors.description ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="color" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{LB_ACTIVE}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={ status }
                                    onChange={ _ => setStatus(!status) }
                                />

                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{INTERNATIONAL}
                    </CardTitle>
                    <CardBody>
                        <SlideLangs
                            langs={langs}
                            setLangs={setlangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>

                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({})

export default connect(mapStateToProps, mapActionsToProps)(SlideForm)